// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, object } from 'prop-types'
import Modal from 'react-modal'

const ModalContainer = ({ children, closeModal }) => (
  <Modal
    className={'modal-content-default'}
    contentLabel={'path export modal container'}
    isOpen={true}
    onRequestClose={closeModal}
    overlayClassName={'modal-overlay-default'}>
    {children}
  </Modal>
)

ModalContainer.propTypes = {
  children: object.isRequired,
  closeModal: func.isRequired,
}

export default ModalContainer
